
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emailsignup/[[...slug]]",
      function () {
        return require("private-next-pages/emailsignup/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emailsignup/[[...slug]]"])
      });
    }
  